/**
 * @render react
 * @name Heading
*/

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import { Link } from 'Components/molecules/Link';

import './_style.scss';

/**
 * Heading component
 *
 * @param {number} size - supported tag size
 * @param {node} children - nested components
 * @param {string} href - URL to link to
 * @param {boolean} loadStyles - Whether to apply the class names for styling
 * @param {Object} extraClassNames - Extra class names to be applied to the component
 *
 */
const Heading = ({
  size,
  children,
  href,
  loadStyles,
  extraClassNames,
  context: { cssPrefix },
}) => {
  const Tag = size > 6 ? 'h6' : `h${size}`;
  return (
    <Tag
      className={classNames({
        [`${cssPrefix}__heading`]: loadStyles,
        ...extraClassNames,
      })}
    >
      {href ? <Link href={href} extraClassNames={{ [`${cssPrefix}__heading--link`]: true }}>{children}</Link> : children}
    </Tag>
  );
};

/**
 * Valid props
 */
Heading.propTypes = {
  size: PropTypes.number,
  children: PropTypes.node,
  href: PropTypes.string,
  loadStyles: PropTypes.bool,
  extraClassNames: PropTypes.shape(),
  context: PropTypes.shape(),
};

/**
 * Default props
 */
Heading.defaultProps = {
  size: 2,
  children: '',
  href: null,
  loadStyles: true,
  extraClassNames: {},
  context: {},
};

export default withPolaris(Heading);
